import React from "react";
import { ArrowRight } from "lucide-react";
import { useSampleRequest } from "../context/SampleRequestContext";

/**
 * Sticky mobile-only bottom CTA bar.
 */
export const MobileCTABar = () => {
  const { openModal } = useSampleRequest();
  
  return (
    <button
      type="button"
      onClick={() => openModal([], "mobile_sticky_cta")}
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-center justify-center gap-2 bg-brand-gold py-4 text-brand-charcoal font-sans font-medium text-sm uppercase tracking-[0.22em] shadow-[0_-12px_40px_-12px_rgba(0,0,0,0.7)] active:bg-[#b8985a] transition-colors"
    >
      Get Free Samples
      <ArrowRight className="h-4 w-4" strokeWidth={2} />
    </button>
  );
};

export default MobileCTABar;
